import React from 'react';
import {Preview, List, Typography, Button} from 'lark';
import helpImgUrl from '@/public/assets/content/ehr.png';

const {Title, Paragraph} = Typography;

const SafeHelp = () => (
    <content className="help-content">
        <List>
            <List.Item>
                <Title>问题一：哪些系统具有安全验证的功能？</Title>
                <Paragraph>解答：目前只有高途课堂和高途在线具有安全验证的功能。</Paragraph>
            </List.Item>
            <List.Item>
                <Title>问题二：如何修改手机号？</Title>
                <Paragraph>
                    解答：登录高途门户（
                    <Button type="link" href="https://home.baijia.com/home">https://home.baijia.com/home</Button>
                    ），依次点击（首页-人事门户-个人信息），点击手机号上方的“点击修改”按钮，依据对应操作完成修改后即可生效；
                </Paragraph>
                <Preview imageUrls={helpImgUrl} toolbar={0}>
                    <Preview.Trigger>
                        <img src={helpImgUrl} alt="首页-人事门户-个人信息" className="help-img" />
                    </Preview.Trigger>
                </Preview>
            </List.Item>
            <List.Item>
                <Title>问题三：手机验证码规则是什么？</Title>
                <Paragraph>解答：手机号验证码为6位验证码，重新获取验证码时间是60s，有效期是10分钟，新的验证码会覆盖原有验证码生效。假设手机停机，获取不到验证码。</Paragraph>
            </List.Item>
        </List>
    </content>
);

export default SafeHelp;
